import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import MenuItem from '@mui/material/MenuItem'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import merge from 'lodash/merge'
import FormTextField from './FormTextField'

const FormSelect = ({ formProps, inputConfig, itemProps }) => {
  const { options = [], sx, onLoadMore, selectProps, ..._inputConfig } = inputConfig || {}
  const formValue = get(formProps, 'field.value')
  const inputValue = inputConfig.value
  const { sx: selectPropsSx = {} } = selectProps || {}

  return (
    <FormTextField
      formProps={formProps}
      inputConfig={{
        sx: {
          width: 195,
          ...(sx || {}),
        },
        ...merge(_inputConfig, {
          inputBaseProps: {
            childrenSx: {
              '& .Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                  border: theme => `2px solid ${theme.palette.btn_positive.main} !important`,
                },
              },
            },
          },
        }),
      }}
      itemProps={itemProps}
      SelectProps={{
        sx: {
          ...merge(
            selectPropsSx,
            isEmpty(formValue) && isEmpty(inputValue)
              ? {
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(0, 0, 0, 0.23) !important',
                  },
                }
              : {},
          ),
        },
        MenuProps: {
          PaperProps: {
            onScroll: event => {
              const listboxNode = event.currentTarget

              if (
                listboxNode.scrollTop + listboxNode.clientHeight >=
                listboxNode.scrollHeight - 10
              ) {
                onLoadMore?.()
              }
            },
          },
          MenuListProps: {
            sx: { maxHeight: 200 },
          },
        },
        IconComponent: KeyboardArrowDownIcon,
      }}
      select
    >
      {options.map(({ label, value, ...optionProps }) => (
        <MenuItem key={`menuitem_${value}`} value={value} {...optionProps}>
          {label}
        </MenuItem>
      ))}
    </FormTextField>
  )
}

export default FormSelect
